import React from 'react';
import { ImageDetail } from '@/components/image-lightbox';
import { CommunityProfileSidebar } from './CommunityProfileSidebar';
import { CommunityProfilePicture, CommunityProfileContext } from '@/types/community-profile';

interface CommunityProfileLightboxProps {
  currentImage: CommunityProfilePicture | null;
  isLightboxOpen: boolean;
  profileContext: CommunityProfileContext;
  onClose: () => void;
}

const CommunityProfileLightbox: React.FC<CommunityProfileLightboxProps> = ({
  currentImage,
  isLightboxOpen,
  profileContext,
  onClose
}) => {
  // For community profiles, we typically only show one image at a time
  // Navigation could be disabled or used for other users in the same thread
  const lightboxImages = currentImage ? [currentImage] : [];

  const handleImageDetailNavigate = (image: CommunityProfilePicture) => {
    // For now, we don't navigate between different users' profile pictures
    // This could be enhanced later to show other users in the same discussion
    console.log('Navigate to image:', image.id);
  };

  return (
    <>
      {/* Universal Image Detail with Community Profile Sidebar */}
      {currentImage && (
        <ImageDetail<CommunityProfilePicture>
          image={currentImage}
          isOpen={isLightboxOpen}
          onClose={onClose}
          allImages={lightboxImages}
          onNavigate={handleImageDetailNavigate}
          getImageUrl={(item) => item.url}
          getImageId={(item) => item.id}
          getImageDescription={(item) => item.alt || `${item.userName}'s profile picture`}
          getUserId={(item) => item.userId}
          getFavoriteCount={() => undefined} // Profile pictures don't have favorites
          showFavoriteButton={false} // Hide favorites for community profile pictures
          showDescription={false} // Hide description for profile pictures
          config={{
            preloading: { enabled: false, strategy: 'conservative', preloadDistance: 0 },
            navigation: { 
              wheel: false, // Disable wheel navigation for single image
              keyboard: false, // Disable keyboard navigation for single image
              clickZones: false // Disable click zones for single image
            },
            mobile: { fullscreen: true, sidebarPosition: 'bottom' }
          }}
          renderSidebar={(item, context) => (
            <CommunityProfileSidebar
              context={context}
              profileContext={profileContext}
            />
          )}
        />
      )}
    </>
  );
};

export default CommunityProfileLightbox; 